import { ChargePoint, Connector } from '../../common/redux/api/web-api'

function getNfcLocked(chargePoint: ChargePoint, connector: Connector | undefined): boolean {
    if (chargePoint?.isOcpp) {
        return connector?.nfcLocked
    }
    return chargePoint?.nfcEnabled && connector?.nfcLocked
}

export default getNfcLocked
